import { render, staticRenderFns } from "./ValidarEmail.vue?vue&type=template&id=31c3c81c&scoped=true"
import script from "./ValidarEmail.vue?vue&type=script&lang=ts"
export * from "./ValidarEmail.vue?vue&type=script&lang=ts"
import style0 from "./ValidarEmail.vue?vue&type=style&index=0&id=31c3c81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c3c81c",
  null
  
)

export default component.exports